class SearchSuggestions extends MenuDrawer {
    constructor() {
        super()
        this.summaryElement = this.querySelector('summary')
        this.input = this.querySelector('input')
        this.closeButton = this.querySelector('[data-search-close]')
        this.clearButton = this.querySelector('[data-search-clear]')
        this.debouncedSearchData = this.debounce(this.onType.bind(this), 500);
        this.form = this.querySelector('.nosto-search');
        this.form.querySelector('svg').addEventListener('click', function() {
            this.form.submit();
        }.bind(this));
        this.input.addEventListener("input", function(event) {
            var search = this.debouncedSearchData();
        }.bind(this));
        this.keywordContainer = this.querySelector('.search-suggestions__list');
        this.asideContainer = this.querySelector('.search-suggestions__aside');
        this.productsContainer = this.querySelector('.search-suggestions__grid');
        this.defaultKeywords = this.keywordContainer.innerHTML;
        this.defaultProducts = this.productsContainer.innerHTML;

        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.onClose.bind(this))
        }

        if (this.clearButton) {
            this.clearButton.addEventListener('click', this.onClear.bind(this))
        }
    }
    debounce(mainFunction, delay) {
        let timer;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                mainFunction(...args);
            }, delay);
        };
    }

    onClose(event) {
        event.preventDefault()
        this.input.value = ''
        this.closeMenuDrawer(this.summaryElement);
    }
    onType() {
        nostojs(api => {
            api.search({
                query: this.input.value,
                products: {
                    fields: ['name', 'price', 'listPrice', 'thumbUrl', 'url'],
                    size: 6
                },
                keywords: {
                    fields: ['keyword', "_highlight.keyword", "_redirect"],
                    highlight: {
                        preTag: '<b>',
                        postTag: '</b>'
                    },
                    size: 4,
                }
            }, {
                track: 'autocomplete'
            }).then(response => {
                this.updateResults(response.keywords, response.products, response.query);
            });
        });
    }
    updateResults(keywords, products, query) {
        var keywordInsert = '';
        if (keywords != null) {
            if (keywords.hits.length > 0) {
                keywords.hits.forEach((keywordItem) => {
                    var buildUrl = window.location.origin + "/search?q=" + encodeURIComponent(keywordItem.keyword);
                    if (keywordItem._redirect != null) {
                        buildUrl = keywordItem._redirect;
                    }
                    keywordInsert += createKeywordLI(buildUrl, keywordItem._highlight.keyword);
                })
            } else if (query != '') {
                var buildUrl = window.location.origin + "/search?q=" + encodeURIComponent(query);
                keywordInsert += createKeywordLI(buildUrl, query);
            } else {
                keywordInsert = this.defaultKeywords;
            }
            if (keywords.hits.length == 0 && products.hits.length == 0 && query != '') {
                this.classList.add('no-results');
            } else {
                this.classList.remove('no-results');
            }
        } else if (query != '') {
            var buildUrl = window.location.origin + "/search?q=" + encodeURIComponent(query);
            keywordInsert += createKeywordLI(buildUrl, query);
        } else {
            keywordInsert = this.defaultKeywords;
        }
        this.keywordContainer.innerHTML = keywordInsert;
        var listItems = this.keywordContainer.querySelectorAll('li a');
        if (listItems.length > 0) {
            listItems.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    var val = item.getAttribute('data-keyword');
                    var link = item.getAttribute('href');
                    nostojs(api => {
                        api.recordSearchClick(
                            'autocomplete', {
                                keyword: val
                            }
                        )
                    })
                    window.location.href = link;
                })
            })
        }
        var productsInsert = '';
        var defaultData = {
            listPrice: 58,
            name: "DEFAULT",
            price: 58,
            productId: "4350478188567",
            thumbUrl: "https://cdn.shopify.com/s/files/1/2445/4975/products/1210077_outerknown_GroovyPocketTee_TCT_f_pdp_copy_large.jpg?v=1695237788",
            url: "https://www.outerknown.com/products/groovy-pocket-tee-terra-cotta"
        };
        if (products != null) {
            if (products.hits.length > 0) {
                products.hits.forEach((productItem) => {
                    productsInsert += createProductLI(productItem);
                })
            } else if (query != '') {

            } else {
                productsInsert = this.defaultProducts;
            }
        } else {
            productsInsert = this.defaultProducts;
        }
        this.productsContainer.innerHTML = productsInsert;
        var listItems = this.productsContainer.querySelectorAll('li a');
        if (listItems.length > 0) {
            listItems.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    var val = item.getAttribute('data-id');
                    var link = item.getAttribute('href');
                    nostojs(api => {
                        api.recordSearchClick(
                            'autocomplete', {
                                productId: val,
                                url: link
                            }
                        )
                    });
                    window.location.href = link;
                })
            })
        }
        this.querySelector('.search-suggestions__container').scrollTop = 0;
        function createKeywordLI(link = '#', text, track = true) {
            var li = '<li class="search-suggestions__list-item p2 color-subdued">';
            li += '<a data-keyword="' + text + '" href="' + link + '" class="full-unstyled-link" >' + text + '</a>';
            li += '</li>';
            return li;
        }

        function createProductLI(productData, track = true) {
            var li = '<li class="search-suggestions__grid-item">';
            li += '<div class="search-suggestions__item">';
            li += '<a data-id="' + productData.productId + '" href="' + productData.url + '" class="search-suggestions__item-image full-unstyled-link">';
            li += '<picture class="img"><img src="' + productData.thumbUrl + '" alt="" class="img__el" loading="eager"></picture>';
            li += '</a>';
            li += '<div class="search-suggestions__item-content">';
            li += '<p class="search-suggestions__item-title h6">';
            li += '<a data-id="' + productData.productId + '" href="' + productData.url + '" class="full-unstyled-link">' + productData.name + '</a>';
            li += '</p>';
            if (current_iso == "US") {
                li += '<p class="search-suggestions__item-meta p2">$' + productData.price + '</p>';
            }
            li += '</div>';
            li += '</div>';
            li += '</li>';
            return li;
        }
    }
}

customElements.define('search-suggestions', SearchSuggestions)